import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const INDUSTRIES = ["Pool Construction & Service", "HVAC", "Plumbing", "Roofing", "Electrical", "Landscaping", "Solar", "Remodeling", "Other"];

export function ClientForm({ value, onChange, disabled }) {
  const upd = (k, v) => onChange({ ...value, [k]: v });
  const F = ({ k, label, type = "text", full }) => (
    <div className={full ? "col-span-2" : ""}>
      <Label>{label}</Label>
      <Input disabled={disabled} type={type} value={value[k] ?? ""} onChange={(e) => upd(k, type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)} className="mt-1" data-testid={`client-field-${k}`} />
    </div>
  );
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <F k="business_name" label="Business Name *" full />
      <F k="website" label="Website" />
      <F k="primary_contact" label="Primary Contact" />
      <F k="email" label="Email" />
      <F k="phone" label="Phone" />
      <div className="col-span-2"><F k="address" label="Address" full /></div>
      <div>
        <Label>Industry</Label>
        <Select disabled={disabled} value={value.industry || ""} onValueChange={(v) => upd("industry", v)}>
          <SelectTrigger className="mt-1" data-testid="client-field-industry"><SelectValue placeholder="Select" /></SelectTrigger>
          <SelectContent>{INDUSTRIES.map((i) => <SelectItem key={i} value={i}>{i}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div>
        <Label>Status</Label>
        <Select disabled={disabled} value={value.status || "Active"} onValueChange={(v) => upd("status", v)}>
          <SelectTrigger className="mt-1" data-testid="client-field-status"><SelectValue /></SelectTrigger>
          <SelectContent>{["Active", "Paused", "Churned"].map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <F k="monthly_vsm_fee" label="Monthly VSM Fee ($)" type="number" />
      <F k="average_job_size" label="Average Job Size ($)" type="number" />
      <F k="assigned_manager" label="Assigned VSM Manager" />
      <F k="start_date" label="Start Date" type="date" />
      <div className="col-span-2"><Label>Notes</Label><Textarea disabled={disabled} value={value.notes || ""} onChange={(e) => upd("notes", e.target.value)} rows={2} className="mt-1" /></div>
      <div className="col-span-2"><Label>First-touch SMS to new leads</Label><Textarea disabled={disabled} value={value.sms_first_touch || ""} onChange={(e) => upd("sms_first_touch", e.target.value)} rows={3} className="mt-1" data-testid="client-field-sms" placeholder="Auto-texted to brand-new leads. Leave blank to use a default. A 'Reply STOP to opt out' line is added automatically." /></div>
      <div className="col-span-2">
        <Label>Brevo API Key (Email Marketing)</Label>
        <Input disabled={disabled} type="password" value={value.brevo_api_key ?? ""} onChange={(e) => upd("brevo_api_key", e.target.value)} className="mt-1" data-testid="client-field-brevo"
          placeholder={value.brevo_configured ? "•••••• saved — paste a new v3 key to replace" : "Paste this client's Brevo v3 API key (xkeysib-…) to pull campaign stats"} />
        {value.brevo_configured
          ? <p className="text-xs text-emerald-600 mt-1" data-testid="brevo-connected-note">Brevo connected. Leave blank to keep the current key.</p>
          : <p className="text-xs text-slate-400 mt-1">Read-only: pulls campaign performance + per-contact email engagement.</p>}
      </div>
    </div>
  );
}
